import React, {Component} from 'react'
import {
  Box,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  Card,
  CardHeader,
  CardBody,
  HStack,
  Badge,
  Divider,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  IconButton,
  Button,
  Textarea,
  Collapse,
  Stack
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './SummaryInfo.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';

// API URL from environment variable with fallback to localhost
const API_URL = process.env.REACT_APP_API_URL || '';

class SummaryInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      feedbackSubmitted: false,
      showBadReason: false,
      badReason: '',
      submittingFeedback: false,
      checkingFeedback: true
    };
  }

  componentDidMount() {
    this.checkExistingFeedback()
  }

  componentDidUpdate(prevProps) {
    // Check feedback when summary changes
    const prevSummary = prevProps.state.selectedSummary
    const currentSummary = this.props.state.selectedSummary

    if (currentSummary && (!prevSummary || prevSummary.id !== currentSummary.id)) {
      this.checkExistingFeedback()
    }
  }

  checkExistingFeedback = async () => {
    const summary = this.props.state.selectedSummary

    if (!summary) {
      return
    }

    this.setState({ checkingFeedback: true })

    try {
      const response = await this.props.authenticatedFetch(
        `${API_URL}/check_summary_feedback/${summary.id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )

      const data = await response.json()

      if (data.success && data.result) {
        this.setState({
          feedbackSubmitted: data.result.has_feedback,
          checkingFeedback: false
        })
      } else {
        this.setState({ checkingFeedback: false })
      }
    } catch (error) {
      console.error('Error checking feedback:', error)
      this.setState({ checkingFeedback: false })
    }
  }

  getCategoryColor = (title) => {
    const colors = {
      'Verkeer': 'orange',
      'Milieu': 'green', 
      'Onderwijs': 'blue',
      'Zorg': 'red',
      'Economie': 'purple',
      'Veiligheid': 'teal',
      'Services': 'gray',
      'Recreatie': 'pink'
    };
    
    const matchedCategory = Object.keys(colors).find(category => 
      title.toLowerCase().includes(category.toLowerCase())
    );
    
    return matchedCategory ? colors[matchedCategory] : 'blue';
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  handleGoodFeedback = async () => {
    await this.submitFeedback(true, '')
  }

  handleBadFeedback = () => {
    this.setState({ showBadReason: true })
  }

  handleReasonChange = (e) => {
    this.setState({ badReason: e.target.value })
  }

  submitBadFeedback = async () => {
    const { badReason } = this.state

    if (!badReason || badReason.trim().length < 10) {
      this.props.toast({
        title: 'Fout',
        description: 'Geef een reden van minimaal 10 karakters waarom deze samenvatting slecht is.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
      return
    }

    await this.submitFeedback(false, badReason)
  }

  submitFeedback = async (isGood, reason) => {
    const summary = this.props.state.selectedSummary

    if (!summary) {
      return
    }

    this.setState({ submittingFeedback: true })

    try {
      const response = await this.props.authenticatedFetch(`${API_URL}/submit_summary_feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          summary_id: summary.id.toString(),
          summary_title: summary.title,
          is_good: isGood,
          reason: reason
        })
      })

      const data = await response.json()

      if (data.success) {
        this.setState({
          feedbackSubmitted: true,
          submittingFeedback: false,
          showBadReason: false,
          badReason: ''
        })

        this.props.toast({
          title: 'Succes!',
          description: data.message,
          status: 'success',
          duration: 5000,
          isClosable: true,
        })
      } else {
        throw new Error(data.message || 'Fout bij indienen feedback')
      }
    } catch (error) {
      console.error('Error submitting feedback:', error)
      this.setState({ submittingFeedback: false })
      this.props.toast({
        title: 'Fout',
        description: error.message || 'Er ging iets mis bij het indienen van je feedback',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    const summary = this.props.state.selectedSummary;
    
    if (!summary) {
      return (
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>Geen samenvatting geselecteerd</AlertTitle>
          <AlertDescription>
            Er is geen samenvatting geselecteerd om te bekijken.
          </AlertDescription>
        </Alert>
      );
    }

    const categoryColor = this.getCategoryColor(summary.title);
    
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
          {/* sidebar */}
          <GridItem
            as="aside"
            colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
            bg="gray.50"
            minHeight={{ lg: '100vh' }}
            p={0}
          >
            <Sidebar
              getFeed = {this.props.getFeed}
              onRouteChange = {this.props.onRouteChange}
              userVersion = {this.props.state.userVersion}
              onLogout = {this.props.onLogout}
            />
          </GridItem>
          <GridItem
            as="main"
            colSpan={{ base: 24, md: 20, lg: 21 }}
            p="10px"
            display="flex"
            flexDirection="column"
            minHeight="100vh"
          >
            <Navigation
              state = {this.props.state}
              onRouteChange = {this.props.onRouteChange}
              getFeed = {this.props.getFeed}
              onVersionChange = {this.props.onVersionChange}
              onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
            />

            <Box p="40px" flex="1">
              <VStack spacing={6} align="stretch">
                {/* Header with back button */}
                <HStack spacing={{ base: 2, md: 4 }} align="center" mb={4}>
                  <IconButton
                    icon={<ArrowBackIcon />}
                    onClick={() => this.props.onRouteChange('overzicht')}
                    variant="ghost"
                    size={{ base: "md", md: "lg" }}
                    color="gray.600"
                    _hover={{ bg: 'gray.100' }}
                  />
                  <VStack align="start" spacing={1} flex="1">
                    <Heading as="h1" size={{ base: "md", md: "lg" }} color="gray.700">
                      {summary.title}
                    </Heading>
                    <VStack align="start" spacing={1}>
                      <Badge
                        colorScheme={categoryColor}
                        variant="solid"
                        fontSize={{ base: "xs", md: "sm" }}
                      >
                        {summary.suggestion_count} SUGGESTIE{summary.suggestion_count !== 1 ? 'S' : ''}
                      </Badge>
                      <Text fontSize={{ base: "xs", md: "sm" }} color="gray.500">
                        Laatst bijgewerkt: {summary.updated_at ?
                          new Date(summary.updated_at).toLocaleString('nl-NL', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          }) :
                          'Onbekend'}
                      </Text>
                    </VStack>
                  </VStack>
                </HStack>

                <Divider />

                {/* Summary content */}
                <Card
                  bg="white"
                  shadow="lg"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.100"
                >
                  <CardHeader>
                    <Heading size="md" color="gray.700">
                      📋 Samenvatting
                    </Heading>
                  </CardHeader>
                  <CardBody pt={0}>
                    <Box
                      color="gray.600"
                      lineHeight="1.8"
                      fontSize="md"
                      sx={{
                        '& h1': { fontSize: '2xl', fontWeight: 'bold', mt: 4, mb: 2, color: 'gray.700' },
                        '& h2': { fontSize: 'xl', fontWeight: 'bold', mt: 4, mb: 2, color: 'gray.700' },
                        '& h3': { fontSize: 'lg', fontWeight: 'semibold', mt: 3, mb: 2, color: 'gray.700' },
                        '& p': { mb: 3 },
                        '& ul': { ml: 6, mb: 3 },
                        '& ol': { ml: 6, mb: 3 },
                        '& li': { mb: 1 },
                        '& strong': { fontWeight: 'bold', color: 'gray.700' },
                        '& em': { fontStyle: 'italic' },
                        '& blockquote': { borderLeft: '4px solid', borderColor: 'gray.300', pl: 4, py: 2, my: 3, fontStyle: 'italic' },
                        '& code': { bg: 'gray.100', px: 1, py: 0.5, borderRadius: 'sm', fontSize: 'sm', fontFamily: 'mono' },
                        '& pre': { bg: 'gray.100', p: 3, borderRadius: 'md', overflow: 'auto', mb: 3 }
                      }}
                    >
                      <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                        {summary.full_summary || summary.summary}
                      </ReactMarkdown>
                    </Box>

                    {/* Feedback Section */}
                    <Divider my={6} />

                    <Box>
                      <Heading size="sm" color="gray.700" mb={3}>
                        💬 Feedback op deze samenvatting
                      </Heading>

                      {this.state.checkingFeedback ? (
                        <HStack spacing={2} color="gray.500">
                          <Text fontSize="sm">Feedback status controleren...</Text>
                        </HStack>
                      ) : this.state.feedbackSubmitted ? (
                        <Alert status="success" borderRadius="md" variant="subtle">
                          <AlertIcon />
                          <Box>
                            <AlertTitle fontSize="md">Je hebt al feedback gegeven</AlertTitle>
                            <AlertDescription fontSize="sm">
                              Bedankt voor je feedback! Dit helpt ons om betere samenvattingen te maken.
                            </AlertDescription>
                          </Box>
                        </Alert>
                      ) : (
                        <VStack spacing={3} align="stretch">
                          <Text fontSize="sm" color="gray.600">
                            Was deze samenvatting nuttig?
                          </Text>

                          <Stack
                            direction={{ base: "column", md: "row" }}
                            spacing={3}
                            w="100%"
                          >
                            <Button
                              colorScheme="green"
                              size="md"
                              onClick={this.handleGoodFeedback}
                              isLoading={this.state.submittingFeedback}
                              isDisabled={this.state.showBadReason}
                              flex={{ base: "1", md: "1" }}
                            >
                              👍 Goede samenvatting
                            </Button>
                            <Button
                              colorScheme="red"
                              variant="outline"
                              size="md"
                              onClick={this.handleBadFeedback}
                              isDisabled={this.state.submittingFeedback || this.state.showBadReason}
                              flex={{ base: "1", md: "1" }}
                            >
                              👎 Slechte samenvatting
                            </Button>
                          </Stack>

                          <Collapse in={this.state.showBadReason}>
                            <VStack spacing={3} align="stretch" mt={2}>
                              <Text fontSize="sm" color="gray.600" fontWeight="semibold">
                                Waarom vind je deze samenvatting slecht?
                              </Text>
                              <Textarea
                                value={this.state.badReason}
                                onChange={this.handleReasonChange}
                                placeholder="Bijvoorbeeld: 'Te algemeen', 'Mist belangrijke details', 'Incorrect', etc."
                                rows={4}
                                bg="white"
                                borderColor="gray.300"
                                _focus={{
                                  borderColor: "red.400",
                                  boxShadow: "0 0 0 1px red.400"
                                }}
                              />
                              <HStack spacing={2}>
                                <Button
                                  colorScheme="red"
                                  size="sm"
                                  onClick={this.submitBadFeedback}
                                  isLoading={this.state.submittingFeedback}
                                  loadingText="Indienen..."
                                >
                                  Feedback Indienen
                                </Button>
                                <Button
                                  variant="ghost"
                                  size="sm"
                                  onClick={() => this.setState({ showBadReason: false, badReason: '' })}
                                  isDisabled={this.state.submittingFeedback}
                                >
                                  Annuleren
                                </Button>
                              </HStack>
                            </VStack>
                          </Collapse>
                        </VStack>
                      )}
                    </Box>
                  </CardBody>
                </Card>


              </VStack>
            </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

          </GridItem>
        </Grid>
      
        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
        />
      </>
    )
  }
}

export default SummaryInfo